import * as yup from 'yup';
import { AuthReducer } from '../../redux/auth';
import store from '../../store/store';
import { CallAPI } from 'actions/General';
import forge from 'node-forge';

const AuthAction = AuthReducer.actions;
const dispatch = store.dispatch;

export const loginSchema = yup.object({
  email: yup.string().required('Email is required'),
  password: yup.string().required('Password is required'),
});

export const userLogin = async (data, setLoader, setApiError) => {
  const result = await CallAPI(
    'LOGIN_API',
    { loginId: data.email, password: await encryptPassword(data.password) },
    null,
    setLoader,
    setApiError,
    null,
  );
  console.log('result', result);
  if (result.status && result.data.status === 'active') {
    dispatch(
      AuthAction.updateAuthState({
        accessToken: result.data.access_token,
        accessRefreshToken: result.data.refresh_token,
      }),
    );
  }
};

export const updateRefreshToken = async () => {
  const result = await CallAPI('REFRESH_AUTH_TOKEN', null, null, null, null, null);
  console.log('result', result);
  if (result.status) {
    dispatch(
      AuthAction.updateAuthState({
        accessToken: result.data.access_token,
        accessRefreshToken: result.data.refresh_token,
      }),
    );
  }
};

const encryptData = (data, publicKeyPem) => {
  try {
    // Convert PEM string to Forge public key object
    const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);

    // Encrypt using RSA-OAEP with SHA-1 (matches your Node backend)
    const encrypted = publicKey.encrypt(data, 'RSA-OAEP', {
      md: forge.md.sha1.create(),
    });

    // Return base64 encoded string
    return forge.util.encode64(encrypted);
  } catch (err) {
    console.error('RSA encryption failed:', err);
    throw err;
  }
};

const encryptPassword = async (password) => {
  // decoding base64 public key
  // eslint-disable-next-line no-undef
  const SERVER_PUBLIC_KEY = atob(process.env.REACT_APP_SERVER_PUBLIC_KEY);
  try {
    return encryptData(password, SERVER_PUBLIC_KEY);
  } catch (err) {
    console.log('Encryption failed', err);
  }
};
